import { render } from "./CustomerContactDetail.vue?vue&type=template&id=2d8008f9"
import script from "./CustomerContactDetail.vue?vue&type=script&lang=js"
export * from "./CustomerContactDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__